module.exports = __webpack_public_path__ + "img/title underline yellow.19b127cd.svg";